import React, { useEffect, useState, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import {
    buscarCategoriasConfiguracion,
    buscarSubcategoriasConfiguracion,
    buscarUnidades,
    editarProductosConfiguracion
} from '../../../actions/configuracion';
import { CustomValueContainer } from '../../../components/react_select/ReactSelect';
import { setAlert } from '../../../actions/alert';

const EditarProductos = ({ productos, reestablecerProductos }) => {

    const dispatch = useDispatch();

    const { listado: listado_categorias } = useSelector(state => state.configuracion.categorias);
    const { listado: listado_subcategorias } = useSelector(state => state.configuracion.subcategorias);
    const { listado: listado_unidades } = useSelector(state => state.configuracion.unidades);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [formData, setFormData] = useState({
        id_categoria: null,
        id_subcategoria: null,
        unidades: []
    });

    const [categoriaData, setCategoriaData] = useState(null);
    const [categoriasFilter, setCategoriasFilter] = useState([]);

    const [subcategoriaData, setSubcategoriaData] = useState(null);
    const [subcategoriasFilter, setSubcategoriasFilter] = useState([]);

    const [tiposData, setTiposData] = useState([]);
    const tiposFilter = [
        { value: 1, label: 'Inventario' },
        { value: 3, label: 'Venta' }
    ];

    const [unidadesData, setUnidadesData] = useState([]);
    const [unidadesFilter, setUnidadesFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided) => ({ ...provided }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: "visible",
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    useEffect(() => {
        if (productos && productos.length > 0) {
            setEditarModal(true);
            dispatch(buscarCategoriasConfiguracion());
            dispatch(buscarUnidades());

            setFormData({
                id_categoria: null,
                id_subcategoria: null,
                unidades: []
            });

            setCategoriaData(null);
            setSubcategoriaData(null);

            setTiposData([]);
            setUnidadesData([]);
        } else {
            setEditarModal(false);
        }
    }, [productos, dispatch]);

    useEffect(() => {
        let options = [];
        for (let i = 0; i < (listado_categorias || []).length; i++) {
            options.push({
                value: listado_categorias[i]._id,
                label: listado_categorias[i].nombre
            });
        }
        setCategoriasFilter(options);
    }, [listado_categorias]);

    useEffect(() => {
        let options = [];
        for (let i = 0; i < (listado_subcategorias || []).length; i++) {
            options.push({
                value: listado_subcategorias[i]._id,
                label: listado_subcategorias[i].nombre
            });
        }
        setSubcategoriasFilter(options);
    }, [listado_subcategorias]);

    useEffect(() => {
        let options = [];
        for (let i = 0; i < (listado_unidades || []).length; i++) {
            options.push({
                value: listado_unidades[i]._id ?? listado_unidades[i].id,
                label: listado_unidades[i].nombre
            });
        }
        setUnidadesFilter(options);
    }, [listado_unidades]);

    const handleSelectCategoria = (option) => {
        const id_categoria = option ? option.value : null;

        setFormData(prev => ({
            ...prev,
            id_categoria,
            id_subcategoria: null
        }));

        setCategoriaData(option);
        setSubcategoriaData(null);

        if (id_categoria) {
            dispatch(buscarSubcategoriasConfiguracion(id_categoria));
        } else {
            setSubcategoriasFilter([]);
        }
    };

    const handleSelectSubcategoria = (option) => {
        const id_subcategoria = option ? option.value : null;

        setFormData(prev => ({
            ...prev,
            id_subcategoria
        }));

        setSubcategoriaData(option);
    };

    const handleAgregarUnidad = () => {
        const unidades = Array.isArray(formData.unidades) ? [...formData.unidades] : [];

        unidades.push({
            id_unidad: '',
            tipo: '',
            cantidad: ''
        });

        setFormData(prev => ({
            ...prev,
            unidades
        }));

        setTiposData(prev => ([...prev, null]));
        setUnidadesData(prev => ([...prev, null]));
    };

    const handleSelectTipo = (option, position) => {
        const unidades = Array.isArray(formData.unidades) ? [...formData.unidades] : [];
        if (!unidades[position]) return;

        unidades[position] = {
            ...unidades[position],
            tipo: option ? option.value : ''
        };

        const tipos = [...tiposData];
        tipos[position] = option || null;

        setTiposData(tipos);

        setFormData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleSelectUnidad = (option, position) => {
        const unidades = Array.isArray(formData.unidades) ? [...formData.unidades] : [];
        if (!unidades[position]) return;

        unidades[position] = {
            ...unidades[position],
            id_unidad: option ? option.value : ''
        };

        const ids = [...unidadesData];
        ids[position] = option || null;

        setUnidadesData(ids);

        setFormData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleCantidadChange = ({ target }) => {
        const nombre_separado = (target.name || '').split('cantidad_');
        const posicion = Number(nombre_separado[1]);
        if (Number.isNaN(posicion)) return;

        const unidades = Array.isArray(formData.unidades) ? [...formData.unidades] : [];
        if (!unidades[posicion]) return;

        unidades[posicion] = {
            ...unidades[posicion],
            cantidad: target.value || ''
        };

        setFormData(prev => ({
            ...prev,
            unidades
        }));
    };

    const handleEliminarUnidad = ({ currentTarget }) => {
        const id_separado = (currentTarget.id || '').split('_');
        const index = Number(id_separado[1]);
        if (Number.isNaN(index)) return;

        const unidades = Array.isArray(formData.unidades) ? [...formData.unidades] : [];
        const tipos = [...tiposData];
        const ids = [...unidadesData];

        unidades.splice(index, 1);
        tipos.splice(index, 1);
        ids.splice(index, 1);

        setFormData(prev => ({
            ...prev,
            unidades
        }));

        setTiposData(tipos);
        setUnidadesData(ids);
    };

    const handleFilasUnidades = (unidades) => {
        const filas = [];

        if (Array.isArray(unidades)) {
            for (let x = 0; x < unidades.length; x++) {
                filas.push(
                    <div className="col-md-12 form-group mb-3" key={`unidad-${x}`}>
                        <div className="input-group h-100">
                            <div className="form-floating h-100">
                                <Select
                                    name="tipo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Tipo de unidad ' + (x + 1)}
                                    options={tiposFilter}
                                    value={tiposData[x] || null}
                                    isClearable={true}
                                    onChange={(value) => handleSelectTipo(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>

                            <div className="form-floating h-100">
                                <Select
                                    name="unidad"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Unidad ' + (x + 1)}
                                    options={unidadesFilter}
                                    value={unidadesData[x] || null}
                                    isClearable={true}
                                    onChange={(value) => handleSelectUnidad(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>

                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Cantidad"
                                    id={'cantidad_' + x}
                                    name={'cantidad_' + x}
                                    value={unidades[x].cantidad || ''}
                                    onChange={handleCantidadChange}
                                />
                                <label htmlFor={'cantidad_' + x}>Cantidad {x + 1}</label>
                            </div>

                            <div className="input-group-append">
                                <button
                                    type="button"
                                    className="btn btn-danger delete"
                                    id={'eliminarUnidad_' + x}
                                    onClick={handleEliminarUnidad}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return filas;
    };

    const handleCerrar = () => {
        if (!statusProcesar) {
            setFormData({
                id_categoria: null,
                id_subcategoria: null,
                unidades: []
            });

            setCategoriaData(null);
            setSubcategoriaData(null);

            setTiposData([]);
            setUnidadesData([]);

            setEditarModal(false);
            reestablecerProductos([]);
        }
    };

    const handleProcesar = async () => {
        if (!formData.id_categoria) {
            dispatch(setAlert('La categoría es requerida', 'danger'));
            return;
        }

        if (!productos || productos.length === 0) {
            dispatch(setAlert('No hay productos seleccionados', 'danger'));
            return;
        }

        setStatusProcesar(true);

        const unidadesLimpias = Array.isArray(formData.unidades)
            ? formData.unidades
                .filter(u => (u?.eliminado ?? 0) === 0)
                .map(u => ({
                    id_unidad: u.id_unidad || '',
                    tipo: u.tipo !== undefined && u.tipo !== null ? u.tipo : '',
                    cantidad: u.cantidad !== undefined && u.cantidad !== null ? u.cantidad : ''
                }))
            : [];

        const ok = await dispatch(
            editarProductosConfiguracion({
                ids_producto: productos,
                id_categoria: formData.id_categoria,
                id_subcategoria: formData.id_subcategoria || null,
                unidades: unidadesLimpias
            })
        );

        setStatusProcesar(false);
        
        if (ok) {
            handleCerrar();
        }
    };


    if (!productos || productos.length === 0) {
        return null;
    }

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .select-group {
                            height: 100%;
                        }

                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }

                        .btn-morado {
                            background: #6f42c1 !important;
                            border-color: #6f42c1 !important;
                            color: #fff !important;
                        }

                        .btn-morado:hover {
                            filter: brightness(0.95);
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal
                show={editarModal}
                size="xl"
                backdrop="static"
                centered
                onHide={handleCerrar}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Editar {productos.length} producto{productos.length === 1 ? '' : 's'}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    name="id_categoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Categoría"
                                    options={categoriasFilter}
                                    value={categoriaData}
                                    isClearable={true}
                                    onChange={handleSelectCategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-6 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    name="id_subcategoria"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Subcategoría (opcional)"
                                    options={subcategoriasFilter}
                                    value={subcategoriaData}
                                    isClearable={true}
                                    onChange={handleSelectSubcategoria}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {handleFilasUnidades(formData.unidades)}
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <small className="text-muted">
                                Se actualizará la categoría/subcategoría y, si agregas unidades,
                                se aplicarán a los {productos.length} productos seleccionados.
                            </small>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {statusProcesar ? (
                        <>
                            <button type="button" className="btn btn-secondary" disabled>
                                Cancelar
                            </button>
                            <button type="button" className="btn btn-morado" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{' '}
                                Unidad
                            </button>
                            <button type="button" className="btn btn-success" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{' '}
                                Guardando...
                            </button>
                        </>
                    ) : (
                        <>
                            <button type="button" className="btn btn-secondary" onClick={handleCerrar}>
                                Cancelar
                            </button>
                            <button type="button" className="btn btn-morado" onClick={handleAgregarUnidad}>
                                <i className="fas fa-plus fa-sm"></i>{' '}
                                Unidad
                            </button>
                            <button type="button" className="btn btn-success" onClick={handleProcesar}>
                                <i className="fas fa-check fa-sm"></i>{' '}
                                Guardar cambios
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EditarProductos;
